/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import { createAction } from '@modules/app/createAction';

import {
    IWizardCollationReportValidateFinishPayload,
    TWizardCollationReportHandleNextAction,
    TWizardCollationReportSetParamsAction,
    TWizardCollationReportSetParamsPayload,
    TWizardCollationReportValidateFinishAction,
    TWizardCollationReportValidateStartAction,
} from './types/wizardCollationReportActionTypes';
import {
    WIZARD_COLLATION_REPORT_HANDLE_NEXT,
    WIZARD_COLLATION_REPORT_SET_PARAMS,
    WIZARD_COLLATION_REPORT_VALIDATE_FINISH,
    WIZARD_COLLATION_REPORT_VALIDATE_START,
} from './wizardCollationReportConstant';

/*
 * -------------------------------------------
 *           VALIDATE
 * -------------------------------------------
 */

export const wizardCollationReportValidateStartAction = (): TWizardCollationReportValidateStartAction =>
    createAction(WIZARD_COLLATION_REPORT_VALIDATE_START);

export const wizardCollationReportValidateFinishAction = (
    payload: IWizardCollationReportValidateFinishPayload,
): TWizardCollationReportValidateFinishAction => createAction(WIZARD_COLLATION_REPORT_VALIDATE_FINISH, payload);

/*
 * -------------------------------------------
 *           SET PARAMS
 * -------------------------------------------
 */

export const wizardCollationReportSetParamsAction = (
    payload: TWizardCollationReportSetParamsPayload,
): TWizardCollationReportSetParamsAction => createAction(WIZARD_COLLATION_REPORT_SET_PARAMS, payload);

/*
 * -------------------------------------------
 *               NEXT
 * -------------------------------------------
 */

export const wizardCollationReportHandleNextAction = (): TWizardCollationReportHandleNextAction =>
    createAction(WIZARD_COLLATION_REPORT_HANDLE_NEXT);
